export default __webpack_public_path__ + "static/media/warning-small.6ad6a0ca.svg";